import request from "@/utils/http";

// 预约列表
export function appointmentList(date) {
  return request
    .get(`/appointment?appointmentDate=${date}`)
    .then(res => res.result);
}

// 添加预约时间
export function addAppointmentTime(data) {
  return request.post("/appointment/time/add", data);
}

// 删除预约时间
export function deleteAppointmentTime(data) {
  return request.post("/appointment/time/delete", data);
}

// 修改预约时间
export function editAppointmentTime(data) {
  return request.post("/appointment/time/update", data);
}

// 预约时间模板
export function useTemplate() {
  return request.post("/appointment/time/use-default");
}

// 获取预约时间列表
export function appointmentTimeList() {
  return request.get("/appointment/time/list").then(res => res.result);
}

// 添加休息日
export function addRest(data) {
  return request.post("/appointment/holiday/add", data);
}

// 删除休息日
export function deleteRest(id) {
  return request.post(`/appointment/holiday/delete?id=${id}`);
}

// 获取休息日列表
export function restList() {
  return request.get("/appointment/holiday/list").then(res => res.result);
}
